import {
  ERROR_CATCHER,
  SEARCH_ERROR_HANDLER_DATADOG_KEY_CASES,
  SEARCH_ERROR_HANDLER_DATADOG_KEY_PREFIX,
  UNKNOWN_VALUE,
} from '../constants';
import { registerErrorMetrics } from './register-error-metrics';
import { Debounce } from './debounce';

const errorList = {
  'Script error': 'script_error',
  'Uncaught ReferenceError': 'uncaught_reference_error',
  'Uncaught TypeError': 'uncaught_type_error',
  'Uncaught SyntaxError': 'uncaught_syntax_error',
  'Uncaught RangeError': 'uncaught_range_error',
  'Uncaught Error: Minified React error #425': 'mismatch_error',
  'Uncaught Error: Minified React error #418': 'mismatch_error',
  'Uncaught Error: Minified React error #423': 'mismatch_error',
  'Uncaught Error: Text content does not match server-rendered HTML.': 'mismatch_error',
  'Uncaught Error: Hydration failed because the initial UI does not match what was rendered on the server.':
    'mismatch_error',
  'Uncaught Error: There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.':
    'mismatch_error',
  'Uncaught Error': 'uncaught_error',
  'Minified React error #418;': 'minified_418',
  'Minified React error #423;': 'minified_423',
  'Minified React error #425;': 'minified_425',
  'Unhandled Promise Rejection': 'unhandled_promise_rejection',
  'Cannot read properties of undefined': 'undefined_destructuring',
};

const debounce = new Debounce(registerErrorMetrics);

function mapErrorTypeTag(errorMessage) {
  if (!errorMessage) {
    return UNKNOWN_VALUE;
  }

  const foundError = Object.keys(errorList).find((error) => errorMessage.includes(error));

  return foundError ? errorList[foundError] : 'generic';
}

export const handlersError = (error) => {
  try {
    const errorType = mapErrorTypeTag(error.message);

    debounce.debounceEvent(error.message)({
      errorType,
      errorCatcher: window?.ERROR_BOUNDARY || ERROR_CATCHER.JS_ERROR,
      errorStack: error.error.stack,
      errorMessage: error.error.message,
    });
  } catch (err) {
    debounce.debounceEvent(err.message)({
      key: `${SEARCH_ERROR_HANDLER_DATADOG_KEY_PREFIX}.${SEARCH_ERROR_HANDLER_DATADOG_KEY_CASES.SCRIPT_CATCH}`,
      errorType: 'sending_error_metric',
      errorCatcher: window?.ERROR_BOUNDARY || ERROR_CATCHER.JS_ERROR,
      errorStack: err.stack,
      errorMessage: err.message,
    });
  }
};
